import { deleteEntry } from '../../../modules/entries/entries.repository';

export const deleteEntryUseCase = (databaseSlug: string, tableSlug: string, uuid: string): Promise<void> => {
  return deleteEntry(databaseSlug, tableSlug, uuid);
};